export default [
    /* 学⽣学习时⻓⽇报 */
  {
    path: "StudyTimeDailyReport",
    name: "StudyTimeDailyReport",
    meta: {
      title: "学⽣学习时⻓⽇报"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/StudyTimeDailyReport/index.vue")
  },
    /* 学⽣学习时⻓周报 */
    {
      path: "StudyTimeWeeklyReport",
      name: "StudyTimeWeeklyReport",
      meta: {
        title: "学⽣学习时⻓周报"
      },
      component: () =>
        import("@/views/Home/ServiceCenter/StudyTimeWeeklyReport/index.vue")
  },
      /* 分析师服务指标周报 */
  {
    path: "AnalystServicesIndicatorsWeeklyReport",
    name: "AnalystServicesIndicatorsWeeklyReport",
    meta: {
      title: "分析师服务指标周报"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/AnalystServicesIndicatorsWeeklyReport/index.vue")
  },
  /* 服务点学员--跟进用户详情 */
  {
    path: "MachineDetails/UserServices",
    name: "MachineDetails/UserServices",
    meta: {
      title: "跟进用户详情"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/MachineDetails/UserServices")
  },
  {
    path:
      "MachineDetails/LearningMachine/:studentId/:studentName/:studentStatus",
    name: "MachineDetails/LearningMachine",
    meta: {
      title: "用户详情"
    },
    component: () => import("@/views/Home/ServiceCenter/ServicePointStudents")
  },
  {
    path: "ServicePointStudents",
    name: "ServicePointStudents",
    meta: {
      title: "服务点学员",
      keepAlive: true
    },
    component: () => import("@/views/Home/ServiceCenter/ServicePointStudents")
  },
  // 视频通话服务操作记录
  {
    path: "VideoServiceOperationRecord",
    name: "VideoServiceOperationRecord",
    meta: {
      title: "视频通话服务操作记录"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/ValueAddedServices/VideoServiceOperationRecord/index.vue"
      )
  },
  /* 学员视频服务管理 */
  {
    path: "StudentVideoManagement",
    name: "StudentVideoManagement",
    meta: {
      title: "学员视频服务管理"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/ValueAddedServices/StudentVideoManagement/index.vue"
      )
  },
  /* 学习机账户 */
  {
    path: "AccountManagement",
    name: "AccountManagement",
    meta: {
      title: "学习机账户"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/MachineAccountManagement/AccountManagement/index.vue"
      )
  },
  /* 班级管理 */
  {
    path: "ClassManagement",
    name: "ClassManagement",
    meta: {
      title: "班级管理"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/ClassManagement/index.vue"
      )
  },
  /* 服务中心账户管理 */
  {
    path: "ServiceCenterAccountManagement",
    name: "ServiceCenterAccountManagement",
    meta: {
      title: "服务中心账户管理"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/ServiceCenterAccountManagement/index.vue"
      )
  },
  /* 云教室跳转页 */
  {
    path: "CloudRoomRedirect",
    name: "CloudRoomRedirect",
    meta: {
      title: "云教室"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/CloudRoomRedirect/index.vue")
  },
  /* 服务中心订阅时长明细 */
  {
    path: "SubscriptionDurationDetails",
    name: "SubscriptionDurationDetails",
    meta: {
      title: "服务中心订阅时长明细"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/SubscriptionDurationDetails/index.vue")
  },

  /* 学习机订阅操作日志 */
  {
    path: "SubscriptionOperationLog",
    name: "SubscriptionOperationLog",
    meta: {
      title: "学习机订阅操作日志"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/SubscriptionOperationLog/index.vue")
  },
  /* 学习机学员账号 */
  {
    path: "AgentStudyList",
    name: "AgentStudyList",
    meta: {
      title: "学习机学员账号"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/MachineAccountManagement/AgentStudyList/index.vue"
      )
  },
  /* 订阅时长明细 */
  {
    path: "LearningMachineChange",
    name: "LearningMachineChange",
    meta: {
      title: "订阅时长明细"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/MachineAccountManagement/LearningMachineChange/index.vue"
      )
  },
  {
    path: "SubscriptionLog",
    name: "SubscriptionLog",
    meta: {
      title: "订阅日志明细"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/MachineAccountManagement/SubscriptionLog/index.vue"
      )
  },
  {
    path: "SubSubscriptionCard",
    name: "SubSubscriptionCard",
    meta: {
      title: "订阅卡采购"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/MachineAccountManagement/SubSubscriptionCard/index.vue"
      )
  },
  {
    path: "RenewalOrder",
    name: "RenewalOrder",
    meta: {
      title: "学习机续订订单"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/MachineAccountManagement/RenewalOrder/index.vue"
      )
  },
  {
    path: "RenewalDetails",
    name: "RenewalDetails",
    meta: {
      title: "订单详情"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/MachineAccountManagement/RenewalOrder/RenewalDetails.vue"
      )
  },

  {
    path: "MallManagement",
    name: "MallManagement",
    meta: {
      title: "商城管理"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/MallManagement/index.vue")
  },
  //学习数据模块
  {
    path: "StudyReport",
    name: "StudyReport",
    meta: {
      title: "报告列表"
    },
    component: () => import("@/views/Home/ServiceCenter/StudyData/StudyReport")
  },
  {
    path: "SleepingDetails",
    name: "SleepingDetails",
    meta: {
      title: "沉睡学员唤醒明细"
    },
    component: () => import("@/views/Home/ServiceCenter/StudyData/SleepingDetails")
  },
  {
    path: "StudentRecord/DurationOfFoundation",
    name: "StudentRecord/DurationOfFoundation",
    meta: {
      title: "打地基时长明细"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/StudyData/50to90_learn_time_list")
  },
  {
    path: "StudentRecord/DetialOfFoundation",
    name: "StudentRecord/DetialOfFoundation",
    meta: {
      title: "打地基明细报表"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/StudyData/schoolStudentFoundationDetail"
      )
  },
  {
    path: "StudentRecord/DurationOfReadWords",
    name: "StudentRecord/DurationOfReadWords",
    meta: {
      title: "念念有词学习时长报表"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/StudyData/campus_foundation_nnyc_time")
  },
  {
    path: "StudentRecord/DetailOfStudentStatistic",
    name: "StudentRecord/DetailOfStudentStatistic",
    meta: {
      title: "用户有效指数统计明细"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/StudyData/campus_student_foundation_valid_detail"
      )
  },
  {
    path: "stsPassportStudyDta",
    name: "stsPassportStudyDta",
    meta: {
      title: "学员通行证学习数据"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/StudyData/stsPassportStudyDta")
  },
  {
    path: "StudentRecord/StudentClassRecord",
    name: "StudentRecord/StudentClassRecord",
    meta: {
      title: "用户记录"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/StudyData/StudentClassRecord")
  },
  {
    path: "StudentRecord/StudentsLearningSituation",
    name: "StudentRecord/StudentsLearningSituation",
    meta: {
      title: "使用情况"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/StudyData/StudentsLearningSituation")
  },
  {
    path: "StudentRecord/DetailsOfKnowledgePoints",
    name: "StudentRecord/DetailsOfKnowledgePoints",
    meta: {
      title: "知识点明细"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/StudyData/DetailsOfKnowledgePoints")
  },
  {
    path: "maintenance",
    name: "maintenance",
    meta: {
      title: "maintenanceManagement"
    },
    component: () => import("@/views/Home/ServiceCenter/Maintenance/index.vue")
  },
  {
    path: "Adjustment",
    name: "Adjustment",
    meta: {
      title: "maintenanceManagement"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/Maintenance/Adjustment.vue")
  },
  {
    path: "ReturnCourierNewProcess",
    name: "ReturnCourierNewProcess",
    meta: {
      title: "maintenanceManagement"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/Maintenance/ReturnCourierNewProcess.vue"
      )
  },
  // 打地基管理——通行证发放记录
  {
    path: "passportRecord",
    name: "passportRecord",
    meta: {
      title: "通行证发放记录"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/DdjManagement/passportRecord/index.vue"
      )
  },
  // 打地基管理——分析师复盘记录
  {
    path: "analystReviewRecord",
    name: "analystReviewRecord",
    meta: {
      title: "分析师复盘记录"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/DdjManagement/analystReviewRecord/index.vue"
      )
  },
  // 打地基管理——学员重新打地基记录
  {
    path: "ddjRestartRecord",
    name: "ddjRestartRecord",
    meta: {
      title: "学员重新打地基记录"
    },
    component: () =>
      import(
        "@/views/Home/ServiceCenter/DdjManagement/ddjRestartRecord/index.vue"
      )
  },
  // 打地基管理——学员打地基学习数据
  {
    path: "ddjStudyData",
    name: "ddjStudyData",
    meta: {
      title: "学员打地基学习数据"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/DdjManagement/ddjStudyData/index.vue")
  },
  {
    path: "VideoCallRecord",
    name: "VideoCallRecord",
    meta: {
      title: "videoCallRecord"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/VideoCallRecord/index.vue")
  },
  {
    path: "studentImproveIndividualAnalysis",
    name: "StudentImproveIndividualAnalysis",
    meta: {
      title: "学员提分效果个体分析"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/StudentImproveIndividualAnalysis/index.vue")
  },
  {
    path: "studentImproveWholeAnalysis",
    name: "StudentImproveWholeAnalysis",
    meta: {
      title: "学员提分效果整体分析"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/StudentImproveWholeAnalysis/index.vue")
  },
  {
    path: "teacherImproveIndividualAnalysis",
    name: "TeacherImproveIndividualAnalysis",
    meta: {
      title: "学员提分效果分析(分析师维度)"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/TeacherImproveIndividualAnalysis/index.vue")
  },
  {
    path: "GuinnessCertificate",
    name: "GuinnessCertificate",
    meta: {
      title: "吉尼斯证书申请"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/GuinnessCertificate/index.vue")
  },
  {
    path: "GuinnessCertificate",
    name: "GuinnessCertificateRoute2",
    meta: {
      title: "吉尼斯证书申请"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/GuinnessCertificate/index.vue")
  },
  {
    path: "suspectedAbnormalDetails",
    name: "suspectedAbnormalDetails",
    meta: {
      title: "疑似异常账号明细"
    },
    component: () => import("@/views/Home/ServiceCenter/AbnormalDataWarning/suspectedAbnormalDetails/index.vue")
  },
  {
    path: "AccountRiskLevel",
    name: "AccountRiskLevel",
    meta: {
      title: "学员账号风控等级"
    },
    component: () => import("@/views/Home/ServiceCenter/RiskControlData/AccountRiskLevel/index.vue")
  },
  {
    path: "million-reward",
    name: "MillionReward",
    meta: {
      title: "百万奖学金"
    },
    component: () => import("@/views/Home/ServiceCenter/MillionReward/index.vue")
  },
  {
    path: "CrossEntitySupervisionQuota",
    name: "CrossEntitySupervisionQuota",
    meta: {
      title: "跨主体督学额度查看"
    },
    component: () => import("@/views/Home/ServiceCenter/CrossEntitySupervisionQuota/index.vue")
  },
  {
    path: "CrossEntitySupervisionApplication",
    name: "CrossEntitySupervisionApplication",
    meta: {
      title: "跨主体督学申请"
    },
    component: () => import("@/views/Home/ServiceCenter/CrossEntitySupervisionApplication/index.vue")
  },
  /* 班级课次信息（排课页面） */
  {
    path: "classFileStudentCourseInformation",
    name: "classFileStudentCourseInformation",
    meta: {
      title: "班级课次信息"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/ClassFileStudentCourseInformation/index.vue")
  },
  /* 督学费核销规则配置 */
  {
    path: "SupervisionFeeWriteOffConfig",
    name: "SupervisionFeeWriteOffConfig",
    meta: {
      title: "督学费自动核销配置"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/SupervisionFeeWriteOffConfig/index.vue")
  },
  /* 点名记录 */
  {
    path: "RollCallRecord",
    name: "RollCallRecord",
    meta: {
      title: "点名记录"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/RollCallRecord/index.vue")
  },
  /* 核销管理 */
  {
    path: "WriteOffManagement",
    name: "WriteOffManagement",
    meta: {
      title: "核销管理"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/WriteOffManagement/index.vue")
  },
  /* 督学申请单核销报表 */
  {
    path: "WriteOffReport",
    name: "WriteOffReport",
    meta: {
      title: "督学申请单核销报表"
    },
    component: () =>
      import("@/views/Home/ServiceCenter/WriteOffReport/index.vue")
  }
];
